import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import MechaPosterStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';
import toWebpImage from '@src/utils/to-webp-image';

const styles = require('./index.less');

//  机甲名称  立绘  编号 机体定位

const MechaPoster = ({ store }) => {
  store.use();
  // const tag = store.mechaMsg?.mecha_positioning_tag?.split('丨');
  return (
    <div className={cx(styles.mechaPosterBox)}>
      <div className={styles.mechaRoleBox} data-name="机甲立绘背景" style={{ backgroundImage: `url(${store.mechaMsg?.mecha_detail_gray_bg})` }} />
      <div className={styles.mechaRole} data-name="机甲立绘" style={{ backgroundImage: `url(${store.mechaMsg?.mecha_detail_image})` }} />
      <div className={styles.mechaInfoBox} data-name="机甲名称+编号+定位">
        <div className={styles.mechaName} data-name="机甲名称">
          {store.mechaMsg?.mecha_name}
        </div>
        <div className={styles.mechaNo} data-name="机甲编号">
          {store.mechaMsg?.mecha_number}
        </div>
        <div className={styles.mechaLocation} data-name="机体定位">
          {store.mechaMsg?.mecha_tag_1}
        </div>
        <div className={styles.mechaLocation} data-name="机体定位">
          {store.mechaMsg?.mecha_tag_2}
        </div>
      </div>
      <Link
        className={styles.mechaInfoBtn}
        style={{ backgroundImage: `url(${toWebpImage(require('../../images/' + store?.mechaStore?.Lang() + '/info-btn.png'))})` }}
        data-name="机兵信息按钮"
        onClick={store.openMechaInfo}
      />
    </div>
  );
};

export default wrapStore(MechaPoster, MechaPosterStore);
